import React from "react";
import { Images } from "../Helper/Index";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1  place-items-center gap-2">
      <img src={Images.NotFound} className="w-[400px] object-cover" alt="not found" />
      <div className="flex font-inter justify-center items-center">
        <p
          onClick={() => navigate(-1)}
          className="bg-brand cursor-pointer text-dynmaicBg2 px-4 py-2 rounded-full"
        >
          Go to back
        </p>
      </div>
    </div>
  );
};

export default NotFound;
